import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Axios from 'axios';
import { BASE_URL } from './helpers/constants';
import i18n from './i18n';
import qs from 'qs'

const $qs = new Vue()
Vue.prototype.$qs = qs

Vue.config.productionTip = false;
const $eventBus = new Vue();
Vue.prototype.$eventBus = $eventBus;

window.axios = new Axios.create({
	baseURL: BASE_URL,
});

new Vue({
	router,
	store,
	vuetify,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
const initialQuery = router.currentRoute.query;
if(!initialQuery.userName && !initialQuery.password && !initialQuery.centerId) {
	if (store.state.login.activeUser) {
		const user = store.state.login.activeUser;
		store.dispatch('login/fetchCenters').then(() => {
			store
				.dispatch('login/login', {
					userName: user.UserName,
					password: user.Password,
					centerId: user.CenterId,
				})
				.then(() => {
				$eventBus.$emit('show-snackbar', false, 'اهلا وسهل بك');
			})
			.catch((err) => {
				if (err.response?.status === 401) {
					store.dispatch('login/logout', { user: user });
					if (router.currentRoute.name !== 'login') router.replace({ name: 'login' });
				}
				$eventBus.$emit('show-snackbar', true, 'حدث خطأ ما');
			})
			.finally(() => {
				$eventBus.$emit('loader', false);
			});
		});
	} else {
		if(!initialQuery.userName && !initialQuery.password && !initialQuery.centerId) {
			router.replace({ name: 'login' })
		}
	}
}

let loggedIn = true;
router.beforeEach((to, from, next) => {
	if (Object.hasOwnProperty.call(to.query, 'desktopApp')) {
		Vue.prototype.$fromEdunix = true;
	} else {
		Vue.prototype.$fromEdunix = false;
	}
	if (from.name) loggedIn = store.state.login.activeUser;
	if (!loggedIn && to.name !== 'login') {
		next({ name: 'login' });
	} else {
		next();
	}
	if(to.query.userName && to.query.password && to.query.centerId) {
		next()
		return;
	}
	if(from.query.isLoginFromTab === 'true') {
		const globalQuery = { isLoginFromTab: 'true' };
		const paramName = Object.keys(globalQuery)[0];
	
		if (to.query[paramName] !== globalQuery[paramName]) {	
			const newQuery = { ...to.query, ...globalQuery };
			return next({ ...to, query: newQuery, replace: true });
		}
	}
});

